var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProphetxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 71,
    viewBox: "0 0 400 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17436_1600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8088 16.5989C54.8088 26.2327 48.8853 36.7128 28.7714 36.7128H19.5281L16.2734 55.4597H0L9.76404 0H32.5468C43.9382 0 54.8088 3.58015 54.8088 16.5989ZM37.3637 17.3149C37.3637 11.9121 33.0024 11.3263 29.8129 11.3263H24.1497L21.546 26.0374H27.2742C34.6949 26.0374 37.3637 21.6111 37.3637 17.3149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3791 15.4918C87.3877 15.4565 88.396 15.5661 89.3734 15.8173L86.8348 30.8539C85.1793 30.4098 83.4715 30.1908 81.7575 30.203C79.4745 29.9883 77.1849 30.5378 75.2481 31.7652C73.0791 33.9406 71.7823 36.8352 71.6029 39.9019L68.8689 55.4593H53.4418L60.4719 15.4918H75.3132L72.9698 28.5105C74.2066 23.1078 78.1122 15.4918 86.3791 15.4918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3735 37.7538C89.215 34.7325 89.7045 31.7122 90.809 28.8955C91.9135 26.0788 93.6075 23.5309 95.7775 21.4226C97.9474 19.3143 100.543 17.6944 103.39 16.6715C106.238 15.6486 109.271 15.2464 112.286 15.4918C120.293 15.4918 131.814 18.421 131.814 33.1322C131.962 36.1594 131.464 39.1833 130.352 42.0029C129.241 44.8225 127.542 47.3731 125.368 49.4852C123.194 51.5973 120.596 53.2224 117.746 54.2524C114.895 55.2825 111.858 55.6939 108.836 55.4593C101.025 55.4593 89.3735 52.465 89.3735 37.7538ZM116.778 32.5463C116.778 26.753 114.044 25.5813 112.026 25.5813C106.558 25.5813 104.54 33.5878 104.54 38.6C104.54 43.6122 107.274 45.5651 109.357 45.5651C114.76 45.5651 116.778 37.4284 116.778 32.5463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.513 15.492H156.68L155.509 22.0013C156.672 19.824 158.457 18.0422 160.636 16.883C162.815 15.7238 165.291 15.2395 167.746 15.492C172.758 15.492 181.09 18.6815 181.09 31.8304C181.09 41.269 176.208 55.3943 161.562 55.3943C158.959 55.3943 152.84 54.0924 151.277 50.8378L147.762 70.3658H131.749L141.513 15.492ZM164.882 32.5465C164.882 26.688 162.213 25.5164 160.195 25.5164C156.745 25.5164 154.467 28.771 153.686 32.6116L152.905 36.387C152.059 40.4879 152.905 45.9557 157.396 45.9557C162.734 46.151 164.882 37.754 164.882 32.5465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.979 0H209.732L205.826 22.4573C207.13 20.3009 208.961 18.512 211.148 17.2593C213.335 16.0066 215.804 15.3313 218.324 15.297C219.89 15.1911 221.46 15.4386 222.918 16.021C224.376 16.6035 225.685 17.5061 226.747 18.6621C227.81 19.8182 228.598 21.1981 229.056 22.7C229.513 24.2019 229.627 25.7874 229.39 27.3393C229.365 29.524 229.147 31.7023 228.739 33.8487L224.833 55.7852H209.081L213.051 32.5468C213.115 32.0498 213.115 31.5466 213.051 31.0496C213.051 27.6648 211.294 26.6884 209.276 26.6884C205.435 26.6884 204.199 29.943 203.483 33.7836L199.772 55.1993H184.215L193.979 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.044 38.6651H248.462C248.461 39.5538 248.641 40.4334 248.992 41.2498C249.344 42.0661 249.858 42.8019 250.505 43.4117C251.151 44.0216 251.916 44.4926 252.751 44.7957C253.586 45.0989 254.475 45.2278 255.362 45.1745C256.826 45.1863 258.264 44.7829 259.508 44.011C260.752 43.2391 261.752 42.1303 262.392 40.8132L272.547 45.565C270.711 48.8334 267.973 51.5043 264.661 53.2587C261.348 55.0132 257.6 55.7771 253.865 55.4593C245.273 55.4593 233.686 52.0744 233.686 37.7538C233.5 34.754 233.96 31.7493 235.034 28.9423C236.108 26.1352 237.772 23.5911 239.912 21.4813C242.053 19.3716 244.621 17.7453 247.443 16.7121C250.266 15.6789 253.277 15.2628 256.273 15.4918C265.582 15.4918 275.151 19.2021 275.151 31.3095C275.142 33.8022 274.769 36.2803 274.044 38.6651ZM261.025 29.0964C261.051 28.3773 260.919 27.6613 260.639 26.9985C260.359 26.3356 259.938 25.7417 259.405 25.2583C258.872 24.7749 258.24 24.4136 257.553 24.1996C256.866 23.9856 256.14 23.924 255.427 24.0191C251.196 24.0191 248.918 27.0134 248.267 31.2445H261.025C261.239 30.5483 261.348 29.8245 261.351 29.0964H261.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.204 15.4919H287.714L289.081 7.48535H304.833L303.466 15.4919H312.449L310.692 25.321H301.709L299.43 38.0142C298.649 42.5708 301.383 43.6774 304.117 43.6774C305.222 43.7735 306.332 43.7735 307.437 43.6774L305.94 54.1574C302.947 55.1761 299.789 55.6179 296.631 55.4593C288.885 55.4593 281.4 53.5716 283.613 38.4048L285.891 25.3861H279.382L281.204 15.4919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.596 55.4599H363.287L352.352 38.9261L365.891 28.7715L383.596 55.4599Z",
    fill: "url(#paint0_linear_17436_1600)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.81 18.4866L400 0H373.507L375.59 3.0594L359.121 15.4272L357.689 16.4687L344.15 26.6233L342.718 27.7299L326.249 40.0326L324.231 36.9732L310.041 55.4598H336.469L334.451 52.3353L350.919 40.0326L352.352 38.926L365.891 28.7714L367.323 27.7299L383.792 15.4272L385.81 18.4866Z",
    fill: "url(#paint1_linear_17436_1600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.444 0H346.688L357.689 16.4687L344.15 26.6233L326.444 0Z",
    fill: "url(#paint2_linear_17436_1600)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17436_1600",
    x1: 390.627,
    y1: 50.1873,
    x2: 340.439,
    y2: 34.6299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A7AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17436_1600",
    x1: 352.872,
    y1: 35.9317,
    x2: 278.861,
    y2: 35.9317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A7AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17436_1600",
    x1: 319.414,
    y1: 5.27258,
    x2: 369.601,
    y2: 20.7648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A7AF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17436_1600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 70.6265,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProphetxLogo);
export default __webpack_public_path__ + "static/media/prophetx-logo.d2c77193e948318a4cf426b5c3726612.svg";
export { ForwardRef as ReactComponent };